import React from 'react'
import {CloseModal} from 'assets/icons'

// Close button of every modal and side panel: the SECONDARY button (components/button) as a
// 40px square icon button, 32px with `size="sm"` (a card). Extra props (hover handlers from a
// Tooltip) reach the button.
const ModalCloseButton = ({onClick, label, size, className = '', ...props}) => (
    <button
        type="button"
        className={`flex ${size === 'sm' ? 'h-8 w-8' : 'h-10 w-10'} shrink-0 items-center justify-center rounded-md border border-gray-100 bg-white text-gray-700 hover:bg-gray-100 active:bg-gray-200 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-500 ${className}`}
        onClick={onClick}
        aria-label={label}
        {...props}
    >
        <CloseModal/>
    </button>
)

export default ModalCloseButton
